import { withQuery } from 'ufo'

export const useStatamicEntries = () => {
    const statamic = useStatamic()

    const getEntries = (data) => {
        let endpoint = `/collections/${data.collection}/entries`

        if (data.limit) {
            endpoint = withQuery(endpoint, { limit: data.limit })
        }

        if (data.filters) {
            data.filters.forEach((filter) => {
                const operator = filter.operator || 'equals'

                endpoint = withQuery(endpoint, {
                    [`filter[${filter.key}:${operator}]`]: filter.value,
                })
            })
        }

        if(data.sort) {
            endpoint = withQuery(endpoint, {
                sort: data.sort,
            })
        }

        return statamic(endpoint)
    }

    const getEntryBy = async (data) => {
        const res = await statamic(
            `/collections/${data.collection}/entries?filter[${data.key}:equals]=${data.value}`,
            {
                transform: (data) => data.data[0] ?? null,
            },
        )

        if (!res.data.value) {
            throw createError({
                statusCode: 404,
                statusMessage: 'Entry not found',
                fatal: true,
            })
        }

        return res
    }

    const getEntryById = (data) => getEntryBy({ ...data, key: 'id' })

    const getEntryBySlug = (data) => getEntryBy({ ...data, key: 'slug' })

    return {
        getEntries,
        getEntryBy,
        getEntryById,
        getEntryBySlug,
    }
}
